module.exports = __webpack_public_path__ + "img/recolumn_example7.4a50a56e.png";